import React from 'react'
import { IUserStatus } from '../_data/user-interface'
import { cn } from '@/lib/utils'

export default function UserStatus(status: IUserStatus) {
  return (
    <div
      className={cn(
        status.clsColor,
        'rounded-lg w-[93px] text-xs text-center font-bold h-8 flex justify-center items-center'
      )}
    >
      {status.title}
    </div>
  )
}
